// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"22":"1b51d60f","530":"82e060e6","719":"0e45fe4c"}[chunkId] + ".chunk.css";
};